import React, { useRef } from 'react';

import AddColorPopUp from '@/components/colors/AddColorPopUp';

const EditColorModal = ({
	directColorPopUp,
	setDirectColorPopUp,
	colorType,
	selectedColorEditList,
	selectedColorEditName,
	defaultColorTitle,
	setIsOverflow,
	disabled,
	onUpdateColor,
	isEditColor,
	productId
}) => {
	const modalRef = useRef(null);

	if (!directColorPopUp) return null;

	return (
		<div
			className="edit-color-modal position-absolute z-index-100"
			style={{ left: 'auto', top: '-72px' }}
		>
			<div ref={modalRef} style={{ display: 'inline-block' }}>
				<AddColorPopUp
					editColorPopUp={directColorPopUp}
					setEditColorPopUp={setDirectColorPopUp}
					colorType={colorType}
					selectedColorEditList={selectedColorEditList}
					selectedColorEditName={selectedColorEditName}
					defaultColorTitle={defaultColorTitle}
					setIsOverflow={setIsOverflow}
					isEdit={true}
					isEditColor={isEditColor}
					productId={productId}
					onAddNewColors={onUpdateColor}
					disabled={disabled}
				/>
			</div>
		</div>
	);
};

export default EditColorModal;
